import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface EntityUpload {
  type: string;
  uploaded: boolean;
  lastUploaded?: string;
}

interface PeriodChecklistCardProps {
  entityUploads: EntityUpload[];
  uploadCompletionPercentage: number;
}

export const PeriodChecklistCard: React.FC<PeriodChecklistCardProps> = ({
  entityUploads,
  uploadCompletionPercentage,
}) => {
  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-muted/50 pb-4">
        <CardTitle className="flex items-center gap-2 text-lg">
          <CheckCircle className="h-5 w-5 text-green-500" />
          Period Checklist
        </CardTitle>
        <CardDescription>
          Required uploads for this reporting period
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="space-y-3">
          {entityUploads.map((item: EntityUpload) => (
            <div
              key={item.type}
              className="flex items-center justify-between"
            >
              <div className="flex flex-col">
                <div className="flex items-center gap-2">
                  {item.uploaded ? (
                    <CheckCircle className="h-4 w-4 text-green-500" />
                  ) : (
                    <div className="h-4 w-4 rounded-full border border-muted" />
                  )}
                  <span className="text-sm font-medium">{item.type}</span>
                </div>
                {item.lastUploaded && (
                  <span className="text-xs text-muted-foreground ml-6">
                    Last upload:{" "}
                    {new Date(item.lastUploaded).toLocaleDateString()}
                  </span>
                )}
              </div>
              <Badge variant={item.uploaded ? "success" : "outline"}>
                {item.uploaded ? "Uploaded" : "Pending"}
              </Badge>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium">Completion</span>
            <span className="text-sm">
              {uploadCompletionPercentage}%
            </span>
          </div>
          <Progress
            value={uploadCompletionPercentage}
            className="h-2"
          />
        </div>
      </CardContent>
    </Card>
  );
}; 